import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ArrowRightOutlined, CalendarOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { idConvocatorias } from "../../../../redux/actions/convocatoriaAction";
import { Convocatoria2 } from "../../../../models/ConvocatoriasModel/convocatoria.model";
import "./cards.style.scss";
import moment from "moment";
import ImageNotFound from "../../../../assets/enmascarar-detail.png";
import { ModalVisualizarEvento } from "../../VerConvocatorias/components/Avisos/ModalVisualizarEvento";
import { useConvocatoriaImage } from "../../../../hooks/useConvocatoriaImage";

interface StateConvocatoria {
  convocatorias: Convocatoria2;
}

export const CardsEvents: React.FC<StateConvocatoria> = (props: StateConvocatoria) => {
  const dispatch = useDispatch();
  const [visualizarEvento, setVisualizarEvento] = useState<boolean>(false);
  const { dataImg, loading } = useConvocatoriaImage(props.convocatorias?.portada_url);

  const mostrarModalPortafolio = () => {
    setVisualizarEvento(true);
  };

  const fechaAperturaString = props.convocatorias.fechas?.find((f) => f.clave === "Apertura")?.valormin;
  const isPast = fechaAperturaString
    ? moment(fechaAperturaString).startOf("day").isBefore(moment().startOf("day"))
    : false;
  const badgeText = isPast ? "Realizado" : "Próximamente";
  const badgeClass = isPast ? "event-status-past" : "event-status-upcoming";

  const fechaFormateada = props.convocatorias.fechas?.find((f) => f.clave === "Apertura")?.valormin
    ? moment(props.convocatorias.fechas.find((f) => f.clave === "Apertura")!.valormin.substring(0, 10)).format("DD MMM / YYYY")
    : "Fecha por definir";

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={() => {
          mostrarModalPortafolio();
          dispatch(idConvocatorias(props.convocatorias.idconvocatorias));
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            mostrarModalPortafolio();
            dispatch(idConvocatorias(props.convocatorias.idconvocatorias));
          }
        }}
        className="modern-event-card-button"
      >
        <article className="modern-event-card">
          <div className="row g-0 h-100">
            {/* Columna de Imagen con badge flotante */}
            <div className="col-12 col-md-5 position-relative event-cover-wrapper">
              <img
                alt={props.convocatorias.nombre_convocatoria}
                className="event-cover-img"
                src={dataImg ? dataImg : ImageNotFound}
                loading="lazy"
              />
              <span className={`event-badge-pill ${badgeClass}`}>
                <span className="badge-pulse-dot" />
                {badgeText}
              </span>
            </div>

            {/* Columna de Información */}
            <div className="col-12 col-md-7 d-flex flex-column justify-content-between p-3">
              <div>
                <h4 className="event-title" title={props.convocatorias.nombre_convocatoria}>
                  {props.convocatorias.nombre_convocatoria}
                </h4>

                <div className="event-date-row">
                  <CalendarOutlined className="date-icon" />
                  <span className="date-text">{fechaFormateada}</span>
                </div>

                {/* Expresiones y Ubicación */}
                <div className="event-meta-tags mt-2">
                  {Array.isArray(props.convocatorias.area) && props.convocatorias.area.length > 0 && (
                    <div className="event-meta-item">
                      <span className="meta-label">Expresión:</span>
                      <span className="meta-value">
                        {props.convocatorias.area.map((a: any) => a?.text || a?.nombre).filter(Boolean).join(", ")}
                      </span>
                    </div>
                  )}

                  {props.convocatorias.objetivo && (
                    <div className="event-meta-item location-item">
                      <EnvironmentOutlined className="location-icon" />
                      <span className="location-text" title={props.convocatorias.objetivo}>
                        {props.convocatorias.objetivo}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Botón de Acción institucional */}
              <div className="event-action-footer">
                <span className="action-label">Ver detalles del evento</span>
                <span className="action-circle">
                  <ArrowRightOutlined />
                </span>
              </div>
            </div>
          </div>
        </article>
      </div>

      <ModalVisualizarEvento
        visualizar={visualizarEvento}
        setVisualizar={setVisualizarEvento}
        convocatorias={props.convocatorias}
      />
    </>
  );
};
